var _g, _g2, _g3, _g4, _g5, _g6, _path, _circle, _circle2, _circle3, _circle4, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgAttrSettingsGraph = function SvgAttrSettingsGraph(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 138,
    height: 133,
    viewBox: "0 0 138 133",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1696_46)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.1925 108.023C30.5946 107.13 30.165 106.115 29.949 105.023L30.5613 104.902C30.4653 104.416 30.4148 103.914 30.4148 103.399V101.422H29.7905V97.4684H30.4148V93.5147H29.7905V89.5611H30.4148V85.6075H29.7905V81.6538H30.4148V77.7002H29.7905V73.7466H30.4148V69.793H29.7905V65.8393H30.4148V61.8857H29.7905V57.9321H30.4148V55.9553C30.4148 55.4403 30.4653 54.9377 30.5613 54.452L29.949 54.3308C30.165 53.2389 30.5946 52.2237 31.1925 51.3306L31.7112 51.6779C32.2735 50.838 32.9967 50.1148 33.8366 49.5525L33.4893 49.0338C34.3824 48.4359 35.3976 48.0063 36.4895 47.7903L36.6107 48.4027C37.0964 48.3066 37.599 48.2561 38.114 48.2561H40.1688V47.6318H44.2785V48.2561H48.3882V47.6318H52.4979V48.2561H56.6076V47.6318H60.7173V48.2561H64.827V47.6318H68.9367V48.2561H73.0463V47.6318H77.156V48.2561H81.2657V47.6318H85.3754V48.2561H89.4851V47.6318H93.5948V48.2561H97.7045V47.6318H101.814V48.2561H103.869C104.384 48.2561 104.887 48.3066 105.372 48.4027L105.493 47.7903C106.585 48.0063 107.601 48.4359 108.494 49.0338L108.146 49.5525C108.986 50.1148 109.709 50.838 110.272 51.6779L110.791 51.3306C111.388 52.2237 111.818 53.2389 112.034 54.3308L111.422 54.452C111.518 54.9377 111.568 55.4403 111.568 55.9553V57.9321H112.192V61.8857H111.568V65.8393H112.192V69.793H111.568V73.7466H112.192V77.7002H111.568V81.6539H112.192V85.6075H111.568V89.5611H112.192V93.5147H111.568V97.4684H112.192V101.422H111.568V103.399C111.568 103.914 111.518 104.416 111.422 104.902L112.034 105.023C111.818 106.115 111.388 107.13 110.791 108.023L110.272 107.676C109.71 108.516 108.986 109.239 108.146 109.802L108.494 110.32C107.601 110.918 106.585 111.348 105.493 111.564L105.372 110.951C104.887 111.048 104.384 111.098 103.869 111.098H101.814V111.722H97.7045V111.098H93.5948V111.722H89.4851V111.098H85.3754V111.722H81.2657V111.098H77.156V111.722H73.0464V111.098H68.9367V111.722H64.827V111.098H60.7173V111.722H56.6076V111.098H52.4979V111.722H48.3882V111.098H44.2785V111.722H40.1688V111.098H38.114C37.599 111.098 37.0964 111.048 36.6107 110.951L36.4896 111.564C35.3976 111.348 34.3824 110.918 33.4893 110.32L33.8366 109.802C32.9967 109.239 32.2735 108.516 31.7112 107.676L31.1925 108.023Z",
    stroke: "#DEE8ED",
    strokeWidth: 1.24851,
    strokeDasharray: "4.16 4.16",
    shapeRendering: "crispEdges"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_1696_46)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.1436 40.1398C13.1436 35.5429 16.8701 31.8164 21.467 31.8164H80.5633C85.1602 31.8164 88.8867 35.5429 88.8867 40.1398V85.0864C88.8867 89.6833 85.1602 93.4098 80.5633 93.4098H21.467C16.8701 93.4098 13.1436 89.6833 13.1436 85.0864V40.1398Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.93
  }, /*#__PURE__*/React.createElement("rect", {
    x: 23.9639,
    y: 44.3037,
    width: 10.8205,
    height: 39.1201,
    rx: 0.832343,
    fill: "#E7F2F7"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 23.9639,
    y: 44.3037,
    width: 10.8205,
    height: 39.1201,
    rx: 0.832343,
    fill: "url(#paint0_linear_1696_46)"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.93
  }, /*#__PURE__*/React.createElement("rect", {
    x: 52.2637,
    y: 44.3037,
    width: 11.6528,
    height: 39.1201,
    rx: 0.832343,
    fill: "#E7F2F7"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.2637,
    y: 44.3037,
    width: 11.6528,
    height: 39.1201,
    rx: 0.832343,
    fill: "url(#paint1_linear_1696_46)"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.93
  }, /*#__PURE__*/React.createElement("rect", {
    x: 38.1133,
    y: 44.3037,
    width: 11.6528,
    height: 39.1201,
    rx: 0.832343,
    fill: "#E7F2F7"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 38.1133,
    y: 44.3037,
    width: 11.6528,
    height: 39.1201,
    rx: 0.832343,
    fill: "url(#paint2_linear_1696_46)"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.93
  }, /*#__PURE__*/React.createElement("rect", {
    x: 67.2451,
    y: 44.3037,
    width: 10.8205,
    height: 39.1201,
    rx: 0.832343,
    fill: "#E7F2F7"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 67.2451,
    y: 44.3037,
    width: 10.8205,
    height: 39.1201,
    rx: 0.832343,
    fill: "url(#paint3_linear_1696_46)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.2129 82.1711L43.9406 58.8655L62.2522 71.3507L86.0548 35.9761L98.4591 26.8203",
    stroke: "#4288F0",
    strokeWidth: 2.49703,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 43.9401,
    cy: 59.2828,
    r: 2.49703,
    fill: "#4288F0",
    stroke: "white",
    strokeWidth: 1.66469
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 62.2526,
    cy: 70.9342,
    r: 2.49703,
    fill: "#4288F0",
    stroke: "white",
    strokeWidth: 1.66469
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 85.5573,
    cy: 35.9782,
    r: 2.49703,
    fill: "#4288F0",
    stroke: "white",
    strokeWidth: 1.66469
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 123.846,
    cy: 14.3373,
    r: 14.1498,
    fill: "#46EEC6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M122.414 16.0228L128.296 9.95737C128.622 9.62077 129.162 9.62008 129.49 9.95583L129.939 10.417C130.254 10.7398 130.254 11.2543 129.94 11.5778L123.012 18.7148C122.685 19.0519 122.144 19.0515 121.817 18.7139L118.581 15.3711C118.268 15.0476 118.269 14.5339 118.583 14.2114L119.031 13.7515C119.359 13.4149 119.9 13.4162 120.226 13.7544L122.414 16.0228Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1696_46",
    x: 13.1437,
    y: 35.1467,
    width: 115.696,
    height: 97.3845,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4.16171
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.32343
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0823529 0 0 0 0 0.117647 0 0 0 0 0.133333 0 0 0 0.03 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1696_46"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1696_46",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_1696_46",
    x: 0.65841,
    y: 23.493,
    width: 100.713,
    height: 86.564,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4.16171
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.24257
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0823529 0 0 0 0 0.117647 0 0 0 0 0.133333 0 0 0 0.07 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1696_46"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1696_46",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1696_46",
    x1: 29.3741,
    y1: 44.3037,
    x2: 29.3741,
    y2: 83.4238,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.526042,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1696_46",
    x1: 58.0901,
    y1: 44.3037,
    x2: 58.0901,
    y2: 83.4238,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.526042,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1696_46",
    x1: 43.9397,
    y1: 44.3037,
    x2: 43.9397,
    y2: 83.4238,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.526042,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1696_46",
    x1: 72.6553,
    y1: 44.3037,
    x2: 72.6553,
    y2: 83.4238,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.526042,
    stopColor: "white",
    stopOpacity: 0
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgAttrSettingsGraph);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/attr-settings-graph.1a44d122924b504d1d480e492a7a14ac.svg";